import Service from "../api/service";
import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "newsletter",
  client: "service",
  omit: ["create", "update", "remove"],
  extras: () => ({
    sendNotification: async (data) =>
      Service.post("/api/v1/newsletter/notification", data),
  }),
  legacy: {
    data: "newsletter",
    count: "count",
    fetch: "fetchNewsletter",
  },
});

export const NewsletterProvider = Provider;
export const useNewsletterContext = useValue;
